/**
 * Kronstadt – Category Buttons Slider
 *
 * Mobile only: buttons swipe natively via CSS overflow-x + scroll-snap.
 * Arrow buttons scroll the row programmatically and disable at the ends.
 */

class KronCategoryButtonsSlider {
  constructor(sectionEl) {
    this.row = sectionEl.querySelector('.kron-cat-buttons__row');
    this.arrowsWrap = sectionEl.querySelector('.kron-cat-buttons__arrows');
    this.prevBtn = sectionEl.querySelector('.kron-cat-arrow--prev');
    this.nextBtn = sectionEl.querySelector('.kron-cat-arrow--next');
    if (!this.row || !this.arrowsWrap || !this.prevBtn || !this.nextBtn) return;

    this.prevBtn.addEventListener('click', () => this.#slide(-1));
    this.nextBtn.addEventListener('click', () => this.#slide(1));
    this.row.addEventListener('scroll', () => this.#updateArrows(), { passive: true });

    new ResizeObserver(() => this.#updateArrows()).observe(this.row);
    this.#updateArrows();
  }

  #slide(dir) {
    const step = this.row.clientWidth * 0.8;
    const maxScroll = this.row.scrollWidth - this.row.clientWidth;
    const target = Math.max(0, Math.min(maxScroll, this.row.scrollLeft + dir * step));
    this.row.scrollTo({ left: target, behavior: 'smooth' });
  }

  #updateArrows() {
    const maxScroll = this.row.scrollWidth - this.row.clientWidth;
    const hasOverflow = maxScroll > 1;
    this.arrowsWrap.hidden = !hasOverflow;
    this.prevBtn.disabled = this.row.scrollLeft <= 1;
    this.nextBtn.disabled = this.row.scrollLeft >= maxScroll - 1;
  }
}

function initKronCategoryButtons() {
  document.querySelectorAll('.kron-cat-buttons').forEach(el => {
    if (el.dataset.kronCatInit) return;
    el.dataset.kronCatInit = 'true';
    new KronCategoryButtonsSlider(el);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initKronCategoryButtons);
} else {
  initKronCategoryButtons();
}
